<template>
    <sub-page class="m-editLedger">
        <el-form :model="ruleForm" :rules="rules" class="form-ledger" ref="ruleForm" label-width="120px" size="small">
            <div class="item-col-2">
                <el-form-item label="值班日期" prop="dutyTime">
                <el-date-picker
                v-model="ruleForm.dutyTime"
                type="daterange"
                range-separator="至"
                start-placeholder="值班开始日期"
                end-placeholder="值班结束日期"
                value-format="yyyy-MM-dd">
                </el-date-picker>
                </el-form-item>
                <el-form-item :label="'科室'" prop="office">
                    <el-popover
                        v-model="orgPopover"
                        placement="right-start"
                        trigger="click" :disabled="status!=0">
                        <select-SingleOrg
                            class="tree-container-pop"
                            style="width: 300px"
                            ref="treeOrg"
                            :isTreePop="true"
                            :defaultCheck="this.ruleForm.officeId"
                            v-on:getTreeNodeData="getNodeValPop"
                        ></select-SingleOrg>
                        <el-input v-model="ruleForm.office" slot="reference" :placeholder="$t('tip.belong')"
                                  :readonly="status==0" :disabled="status!=0"></el-input>
                        <input type="hidden" :value="ruleForm.officeId">
                    </el-popover>
            </el-form-item>
            
                <el-form-item label="值班队长" prop="captain">
                    <el-input v-model="ruleForm.captain" placeholder="请输入值班队长" clearable></el-input>
                </el-form-item>
                <el-form-item :label="'分队总人数'" prop="contingentNum">
                    <el-input-number v-model="ruleForm.contingentNum" controls-position="right" :precision="0" :min="0" :max="10000"></el-input-number>
                </el-form-item>
                <el-form-item label="分队出勤人数" prop="contingentAttendance">
                    <el-input-number v-model="ruleForm.contingentAttendance" controls-position="right" :precision="0" :min="0" :max="10000"></el-input-number>
                </el-form-item>
                <el-form-item label="逸飞祥/员通/外岗/体测人数" prop="offStaffNum" label-width="200px">
                    <el-input-number v-model="ruleForm.offStaffNum" controls-position="right" :min="0" :precision="0" :max="10000"></el-input-number>
                </el-form-item>
                <el-form-item label="加班人数" prop="overtimeNum">
                    <el-input-number v-model="ruleForm.overtimeNum" controls-position="right" :min="0" :precision="0" :max="10000"></el-input-number>
                </el-form-item>
                <el-form-item label="出勤总人数" prop="attendanceNum">
                    <el-input-number v-model="ruleForm.attendanceNum" controls-position="right" :precision="0" :min="0" :max="10000"></el-input-number>
                </el-form-item>
            </div>

            <!-- 培训人员 -->
            <el-form-item label="当日国内出发值班人员添加" prop="inlandMembers" class="item-participants">
                <div class="trainee">
                    <el-tag size="mini" @close="deleteInlandUser(index)" v-for="(item, index) in ruleForm.inlandMembers" :key="item.userId" closable>{{item.userName}}</el-tag>
                </div>
                <el-button @click="addInlandUser" type="primary" circle size="small" title="添加国内出发值班人员"><i class="nucfont inuc-add"></i></el-button>
            </el-form-item>
            <!-- 培训人员 -->
            <el-form-item label="当日外岗值班人员添加" prop="offStaffMembers" class="item-participants">
                <div class="trainee">
                    <el-tag size="mini" @close="deleteOffStaffUser(index)" v-for="(item, index) in ruleForm.offStaffMembers" :key="item.userId" closable>{{item.userName}}</el-tag>
                </div>
                <el-button @click="addOffStaffUser" type="primary" circle size="small" title="添加外岗值班人员"><i class="nucfont inuc-add"></i></el-button>
            </el-form-item>
            <!-- 培训人员 -->
            <el-form-item label="当日紧急其他值班人员添加" prop="emergencyMembers" class="item-participants">
                <div class="trainee">
                    <el-tag size="mini" @close="deleteEmergencyUser(index)" v-for="(item, index) in ruleForm.emergencyMembers" :key="item.userId" closable>{{item.userName}}</el-tag>
                </div>
                <el-button @click="addEmergencyUser" type="primary" circle size="small" title="添加紧急其他值班人员"><i class="nucfont inuc-add"></i></el-button>
            </el-form-item>
            <!-- 附件 -->
            <el-form-item class="item-files">
                <template v-slot:label>
                    <div>附件 (<span style="color:#22B9FF"> {{ruleForm.accessory.length}} </span>)</div>
                </template>

                <div class="file-area">
                    <ledger-file :initFiles="initFiles" @file-change="fileChange"></ledger-file>
                </div>
            </el-form-item>

            <div class="btn-group">
                <el-button type="primary" @click="toSave" :loading="submitLoading">保存</el-button>
            </div>
        </el-form>

        <!-- inland dialog -->
        <trainee-dialog :traineeDialog.sync="inlandDialog"
                        :selectedTable="[...ruleForm.inlandMembers,...ruleForm.offStaffMembers,...ruleForm.emergencyMembers]"
                        :filterType="1" :notStudent="true"
                        @dialog-save="inlandDialogSave"
        ></trainee-dialog>
        <!-- offStaff dialog -->
        <trainee-dialog :traineeDialog.sync="offStaffDialog"
                        :selectedTable="[...ruleForm.inlandMembers,...ruleForm.offStaffMembers,...ruleForm.emergencyMembers]"
                        :filterType="1" :notStudent="true"
                        @dialog-save="offStaffDialogSave"
        ></trainee-dialog>
        <!-- emergency dialog -->
        <trainee-dialog :traineeDialog.sync="emergencyDialog"
                        :selectedTable="[...ruleForm.inlandMembers,...ruleForm.offStaffMembers,...ruleForm.emergencyMembers]"
                        :filterType="1" :notStudent="true"
                        @dialog-save="emergencyDialogSave"
        ></trainee-dialog>
    </sub-page>
</template>

<script>
    import api from '@/api';
    import SubPage from '@/components/Subpage.vue'
    import selectSingleOrg from '@/components/SelectSingleOrg.vue';
    import traineeDialog from '@/components/Dialog/TraineeDialog'
    import ledgerFile from './Components/File'

    export default {
        props: ['attendanceId','type'],
        components: {
            SubPage,
            selectSingleOrg,
            traineeDialog,
            ledgerFile
        },
        data() {
            return {
                orgPopover: false,
                ruleForm: {
                    dutyTime: [],
                    office: '',
                    officeId:'',
                    captain: '',
                    contingentNum: 0,
                    contingentAttendance: 0,
                    offStaffNum: 0,
                    overtimeNum:0,
                    attendanceNum:0,
                    inlandMembers: [],
                    offStaffMembers: [],
                    emergencyMembers:[],
                    accessory: [],
                },
                status:0,
                rules: {
                    dutyTime: [{required: true, message: '请选择排班日期', trigger: 'blur'}],
                    office: [{required: true, message: '请选择科室', trigger: 'change'}],
                    captain: [
                        {max: 20, message: this.$t('rule.maxLength', ['20']), trigger: 'blur'}
                    ],
                },

                inlandDialog: false,
                offStaffDialog: false,
                emergencyDialog: false,
                submitLoading: false,
                checkedOrgs: [],
                initFiles: []
            }
        },
        created() {

            // 编辑
            if (this.attendanceId) {
                this.initData()
            }
        },
        computed: {
            
        },
        methods: {
            //所属机构的获取数据的方法处理
            getNodeValPop(data){
                // this.$set(this.ruleForm, 'office', data.name);
                // this.$set(this.ruleForm, 'officeId', data.id);
                this.ruleForm.officeId = data.id;
                this.ruleForm.office = data.name;
                this.orgPopover = false;
            },
            initData() {
                api.getTimeSheetPlanDetail(this.attendanceId).then(res => {
                    let data = res.data;
                    if(this.type!='clone'){
                        this.status = res.data.status;
                    }
                    for (let item in data) {
                        if (this.ruleForm.hasOwnProperty(item)) {
                            this.ruleForm[item] = data[item];
                        }
                    }
                    this.ruleForm.dutyTime = [data.dutyStart,data.dutyEnd];
                    // this.checkedOrgs = data.institutions.map(item => item.orgId)
                    this.initFiles = data.accessory;

                })
            },

            addInlandUser() {
                this.inlandDialog = true;
            },
            addOffStaffUser() {
                this.offStaffDialog = true;
            },
            addEmergencyUser() {
                this.emergencyDialog = true;
            },
            deleteInlandUser(n) {
                this.ruleForm.inlandMembers.splice(n ,1)
            },
            deleteOffStaffUser(n) {
                this.ruleForm.offStaffMembers.splice(n ,1)
            },
            deleteEmergencyUser(n) {
                this.ruleForm.emergencyMembers.splice(n ,1)
            },
            inlandDialogSave(data) {
                // this.ruleForm.inlandMembers = [];

                data.forEach(item => {
                    this.ruleForm.inlandMembers.push({
                        userId: item.id,
                        userName: item.name
                    })
                })

                this.inlandDialog = false;
                this.$refs["ruleForm"].validateField('inlandMembers');
            },
            offStaffDialogSave(data) {
                // this.ruleForm.offStaffMembers = [];

                data.forEach(item => {
                    this.ruleForm.offStaffMembers.push({
                        userId: item.id,
                        userName: item.name
                    })
                })

                this.offStaffDialog = false;
                this.$refs["ruleForm"].validateField('offStaffMembers');
            },
            emergencyDialogSave(data) {
                data.forEach(item => {
                    this.ruleForm.emergencyMembers.push({
                        userId: item.id,
                        userName: item.name
                    })
                })

                this.emergencyDialog = false;
                this.$refs["ruleForm"].validateField('emergencyMembers');
            },
            fileChange(fileList) {
                this.ruleForm.accessory = fileList.map(item => {
                    return item.response&&item.response.data&&item.response.data[0];
                })
            },

            toSave() {
                this.$refs["ruleForm"].validate((valid) => {
                    if (!valid) return;
                    if(this.ruleForm.emergencyMembers.length==0&&this.ruleForm.offStaffMembers.length==0&&this.ruleForm.inlandMembers.length==0){
                        this.$message({
                        type: 'warning',
                        message: '无任何值班人员！'
                    });
                       return; 
                    }
                    let result = {
                        ...this.ruleForm,
                        dutyStart:this.ruleForm.dutyTime[0].substring(0, 10),
                        dutyEnd:this.ruleForm.dutyTime[1].substring(0, 10),
                        };
                    delete result.dutyTime;
                    this.submitLoading = true;

                    if (this.attendanceId&&this.type=='edit') {
                        api.editTimeSheetPlan(this.attendanceId,result).then(res => {
                            this.$notify({
                                title: res.message,
                                message: '排班修改成功！',
                                type: 'success',
                                duration: 2000
                            });

                            this.submitLoading = false;
                            this.$emit('onClose');
                            this.$router.replace({name: 'scheduleSetting'})
                        }).catch(e => this.submitLoading = false);
                    } else {
                        api.addTimeSheetPlan(result).then(res => {
                            this.$notify({
                                title: res.message,
                                message: this.type=='clone'?'排班克隆成功！':'排班添加成功！',
                                type: 'success',
                                duration: 2000
                            });

                            this.submitLoading = false;
                            this.$emit('onClose');
                            this.$router.replace({name: 'scheduleSetting'})
                        }).catch(e => this.submitLoading = false);
                    }

                })
            },
        },
        watch: {
            
        },
    }
</script>

<style scoped lang="scss">
    .form-ledger {
        width: 1000px;
        @media screen and (max-width: 1366px) {
            width: 690px;
        }

        .el-form-item {
            //margin-bottom: 16px;
        }

        .item-col-2 {
            display: flex;
            flex-wrap: wrap;
            .el-form-item {
                flex-basis:50%;
            }
        }

        .creator .el-form-item {
            color: #999;
        }

        .item-participants {
            .trainee {
                min-height: 120px;
                max-height: 240px;
                padding: 5px;
                line-height: 30px;
                border: 1px solid #DCDFE6;
                border-radius: 4px;
                overflow-y: auto;
                .el-tag {
                    margin-left: 10px;
                }
            }
            button {
                position: absolute;
                top: 50%;
                margin-top: -16px;
                right: -50px;
            }
        }

        .item-files {
            .file-area {
                min-height: 172px;
                max-height: 480px;
                padding: 10px 10px 0 10px;
                border: 1px solid #cad8e1;
                overflow-y: auto;
            }
        }
    }

    .btn-group {
        margin-top: 30px;
        margin-bottom: 20px;
        text-align: center;
    }

    @media screen and (max-width: 1440px) {
        .form-ledger {
            //width: 900px;
        }
    }
</style>
